import { datadogRum } from '@datadog/browser-rum'
import {
  isDatadogRumEnabled,
  DATADOG_RUM_APPLICATION_ID,
  DATADOG_RUM_CLIENT_TOKEN,
  DATADOG_RUM_ENV,
} from 'config/portal'

/* eslint-disable no-console */

function initialize() {
  // Skip initializing if Datadog RUM feature flag is disabled or if Cypress is running
  if (!isDatadogRumEnabled() || globalThis.Cypress) return

  // Credentials are required when feature flag is enabled
  if (!DATADOG_RUM_APPLICATION_ID || !DATADOG_RUM_CLIENT_TOKEN) {
    return console.error(
      'ERROR: Datadog RUM is enabled but credentials are not configured. Both "REACT_APP_DATADOG_RUM_APPLICATION_ID" and "REACT_APP_DATADOG_RUM_CLIENT_TOKEN" environment variables must be defined.'
    )
  }

  try {
    datadogRum.init({
      applicationId: DATADOG_RUM_APPLICATION_ID,
      clientToken: DATADOG_RUM_CLIENT_TOKEN,
      site: 'datadoghq.com',
      service: 'rsp-client',
      env: DATADOG_RUM_ENV,
      version: process.env.REACT_APP_VERSION,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
    })
    datadogRum.startSessionReplayRecording()
  } catch (e) {
    console.warn(`WARNING: Datadog RUM initialization failed: ${e}`)
  }
}

// Initialize on import
initialize()
